import type { ILanguageResources, ITranslationModule } from '../../interfaces';
import { interpolate } from '../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.api.EventSource.';
  public static readonly connectedMarkdown = `${Id.prefix}connectedMarkdown`;
  public static readonly dontShowAgain = `${Id.prefix}dontShowAgain`;
}

export class LangEventSource {
  private constructor() {}
  public static connectedMarkdown(): string {
    return interpolate(Id.connectedMarkdown);
  }
  public static dontShowAgain(): string {
    return interpolate(Id.dontShowAgain);
  }
}

export class EventSourceModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.connectedMarkdown,
      "**You are now receiving live updates from server as they happen.**\n\nYour {{glossary 'quote:plural'}} and {{glossary 'project:plural'}} will refresh as data is updated on the server.",
      'Markdown message shown when event source connects'
    );
    register.add(
      Id.dontShowAgain,
      "Don't show again",
      'Button label to not show the event source connection message again'
    );
  }
}
